module.exports = __webpack_public_path__ + "img/W-C35.106f2a63.jpg";